import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Spacings, BgColors } from '../../../../styleConstants';
import Sections from './Sections';

const SectionsWrapper = styled.div`
  display: grid;
  grid-column-gap: ${Spacings.SPACING_10B};
  padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_12B};
  grid-template: 1fr / repeat(3, max-content);
  justify-content: center;
  background: ${BgColors.WHITE};
  z-index: 15;
`;

const HeaderSectionsMobile = ({ headerRefs }) => {
  return (
    <SectionsWrapper>
      <Sections headerRefs={headerRefs} />
    </SectionsWrapper>
  );
};

HeaderSectionsMobile.propTypes = {
  headerRefs: PropTypes.objectOf(PropTypes.object).isRequired
};

export default HeaderSectionsMobile;
